import React from 'react';

export default function HousingAllowanceSchoolModalContent() {
  return (
    <>
      <div>
        <p>
          Under the GI Bill you’re eligible to receive a monthly housing
          allowance. We calculate this monthly housing allowance based on where
          you take classes.
        </p>
        <a href="https://www.benefits.va.gov/gibill/resources/benefits_resources/rate_tables.asp">
          View the current housing allowance payment rates
        </a>
      </div>
    </>
  );
}
